import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { api } from '../services';
import axios from 'axios';
import moment from 'moment';
import AppointmentPDF from '../components/AppointmentPDF';
import { formatNumberWithPersianSeparators } from '../utils/formatNumber';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  CircularProgress,
} from '@mui/material';

const oId=process.env.REACT_APP_OID;

// فونت ایران‌سنس به صورت Base64
const IRAN_SANS_NORMAL = "YOUR_FONT_BASE64_HERE";

// تابع کمکی برای تبدیل AM/PM به قبل ظهر/بعد ظهر
const formatTurnTime = (turnTime) => {
  if (!turnTime || typeof turnTime !== 'string') return turnTime;
  
  // ابتدا AM/PM را به فارسی تبدیل می‌کنیم
  const persianTime = turnTime.replace(/AM/i, 'قبل ظهر').replace(/PM/i, 'بعد ظهر');
  
  // سپس اعداد را به فارسی تبدیل می‌کنیم
  return convertToFarsiNumber(persianTime);
};

// تابع تبدیل اعداد انگلیسی به فارسی
const convertToFarsiNumber = (number) => {
  if (!number) return '۰';
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return number.toString().replace(/\d/g, x => farsiDigits[x]);
};

// تابع تبدیل اعداد به فارسی با جداکننده هزارگان
const formatFarsiPrice = (price) => {
  if (!price) return '۰';
  return convertToFarsiNumber(price.toLocaleString());
};

export const HistoryPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [historyData, setHistoryData] = useState([]);
  const [userInfo, setUserInfo] = useState({
    fullName: localStorage.getItem('fullName') || '',
    phoneNumber: localStorage.getItem('phoneNumber') || '',
    key: localStorage.getItem('key') || ''
  });

  console.log('Initial userInfo:', userInfo); // لاگ اولیه برای نمایش مقادیر اولیه

  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ open: false, message: '', severity: 'success' });
  const [confirmModal, setConfirmModal] = useState({ open: false, item: null }); // state جدید برای مدال تأیید
  const [infoModal, setInfoModal] = useState({ open: false }); // state جدید برای مدال اطلاعات
  const [walletAmount, setWalletAmount] = useState(0);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        console.log('Fetching profile with key:', userInfo.key);
        setLoading(true);
        const response = await api.get(`Home/GetProfileInfo?SesID=${userInfo.key}&OID=${oId}`);
        
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (parseError) {
            console.error('Error parsing JSON:', parseError);
          }
        }

        if (data && data[0]) {
          const firstName = data[0].Fname || '';
          const lastName = data[0].Lname || '';
          const fullName = `${firstName} ${lastName}`.trim();
          const bedehi = data[0].Bedehi;
          
          console.log('Extracted data:', {
            firstName,
            lastName,
            fullName,
            bedehi
          });
          
          if (fullName) {
            localStorage.setItem('fullName', fullName);
            setUserInfo(prev => ({
              ...prev,
              fullName: fullName
            }));
          }

          // اگر Bedehi منفی باشد، آن را به عنوان موجودی کیف پول در نظر می‌گیریم
          if (bedehi && bedehi < 0) {
            const amount = Math.abs(bedehi);
            setWalletAmount(amount);
            console.log('Setting wallet amount:', amount);
          }
        }
      } catch (error) {
        console.error('Error fetching profile info:', error);
        setModal({ open: true, message: 'خطا در دریافت اطلاعات پروفایل', severity: 'error' });
      } finally {
        setLoading(false);
        setConfirmModal({ open: false, item: null });
      }
    };
    
    if (userInfo.key) {
      fetchProfile();
    }
  }, [userInfo.key]);

  // دریافت تاریخچه نوبت‌ها (نمایش تمام نوبت‌ها بدون تجمیع بر اساس TransactionNum)
  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await api.get(`Home/ReportNobat?SDId=${userInfo.key}&OID=${oId}`);
      let data = response.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          data = [];
        }
      }

      const normalized = Array.isArray(data) ? data : [];
      setHistoryData(normalized);
    } catch (error) {
      console.error('Error fetching history data:', error);
      setModal({ open: true, message: 'خطا در دریافت تاریخچه نوبت‌ها', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userInfo.key) { // Check if key exists
      fetchHistory();
    }
  }, [userInfo.key]);

  // مدیریت کلیک روی دکمه لغو برای نمایش مدال تأیید
  const clickHandler = (item) => {
    setConfirmModal({ open: true, item }); // باز کردن مدال تأیید و ذخیره آیتم
  };

  // مدیریت تأیید لغو نوبت
  const confirmCancel = async () => {
    const { item } = confirmModal;
    try {
      setLoading(true);
      // تبدیل تاریخ به فرمت YYYY-MM-DD
      const formattedTurnDate = moment(item.TurnDate).format('YYYY-MM-DD');
      
      // ساخت URL کامل برای استرداد
      const esterdadURL = `Home/Esterdad?SDId=${userInfo.key}&OID=${oId}&TransactionNum=${item.TransactionNum}&TurnDate=${formattedTurnDate}&RID=${item.ID}`;

      console.log('Refund URL:', esterdadURL);

      const response = await api.post(esterdadURL);

      console.log('Refund response:', response);

      // بررسی پاسخ API
      let responseData = response.data;
      if (typeof responseData === 'string') {
        try {
          responseData = JSON.parse(responseData);
        } catch {
          // ignore parse error, keep as string
        }
      }

      // موفقیت زمانی است که سرویس مبلغ استرداد را برگرداند
      let refundedAmount = null;
      if (typeof responseData === 'number') {
        refundedAmount = responseData;
      } else if (typeof responseData === 'string') {
        const numeric = responseData.replace(/[^0-9]/g, '');
        if (numeric) {
          refundedAmount = parseInt(numeric, 10);
        }
      } else if (typeof responseData === 'object' && responseData) {
        const candidate = responseData.Amount ?? responseData.amount ?? responseData.Price ?? responseData.price ?? responseData.ReturnMoney ?? responseData.returnMoney ?? responseData.ServicePrice ?? responseData.servicePrice;
        if (candidate != null) {
          const n = parseInt(String(candidate).replace(/[^0-9]/g, ''), 10);
          if (!isNaN(n)) refundedAmount = n;
        }
      }

      if (refundedAmount && refundedAmount > 0) {
        setConfirmModal({ open: false, item: null });
        setModal({ 
          open: true, 
          message: 'استرداد با موفقیت انجام شد', 
          severity: 'success' 
        });
        setTimeout(() => {
          setModal(prev => ({ ...prev, open: false }));
          navigate(0);
        }, 1500);
      } 
    } catch (error) {
      console.error('Error processing refund:', error);
      
      let errorMessage = 'خطا در لغو نوبت. ';
      if (error.response?.data) {
        // اگر پیام خطا از سرور وجود دارد، آن را نمایش دهیم
        errorMessage = error.response.data;
      } else if (error.response?.status === 401) {
        errorMessage = 'لطفاً دوباره وارد سیستم شوید.';
      } else if (error.response?.status === 403) {
        errorMessage = 'امکان لغو نوبت در این زمان وجود ندارد.';
      } else if (error.response?.status === 404) {
        errorMessage = 'نوبت مورد نظر یافت نشد.';
      } else if (error.response?.status === 500) {
        errorMessage = 'خطا در سیستم رخ داده است. لطفاً دوباره تلاش کنید.';
      } else {
        errorMessage = 'خطا در لغو نوبت. لطفاً دوباره تلاش کنید.';
      }
      
      setModal({ 
        open: true, 
        message: errorMessage,
        severity: 'error' 
      });
      setConfirmModal({ open: false, item: null });
    } finally {
      setLoading(false);
      setConfirmModal({ open: false, item: null });
    }
  };

  // بستن مدال اطلاع‌رسانی
  const handleCloseModal = () => {
    setModal({ ...modal, open: false });
  };

  // بستن مدال تأیید
  const handleCloseConfirmModal = () => {
    setConfirmModal({ open: false, item: null });
  };

  // باز کردن مدال اطلاعات
  const handleOpenInfoModal = () => {
    setInfoModal({ open: true });
  };

  // بستن مدال اطلاعات
  const handleCloseInfoModal = () => {
    setInfoModal({ open: false });
  };

  // نویگیشن‌ها
  const mainload = () => navigate('/');
  const profilePage = () => navigate('/editprofile');
  const handelPay = () => navigate('/payment');
  const exitUser = () => {
    localStorage.removeItem('phoneNumber');
    localStorage.removeItem('key');
    navigate('/');
  };

  // حذف تابع handlePrint قدیمی
  const handleBack = () => {
    navigate(-1);
  };

  // اضافه کردن نمایش موجودی کیف پول در UI
  const renderWalletAmount = () => {
    if (walletAmount > 0) {
      return (
        <div className="wallet-amount" style={{ 
          padding: '10px', 
          margin: '10px 0',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          {/* <span>موجودی کیف پول: </span>
          <strong>{walletAmount.toLocaleString()} ریال</strong> */}
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            max-width: 400px;
            width: 90%;
            margin: 0 10px;
            text-align: center;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          .modal-content h4 {
            margin-bottom: 15px;
            color: ${modal.severity === 'success' ? '#2e7d32' : '#d32f2f'};
          }
          .modal-content .button-container {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 20px;
          }
          .modal-content button {
            background: #0db2ba;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            min-width: 100px;
          }
          .modal-content button:hover {
            opacity: 0.9;
          }
          .modal-content .cancel-button {
            background: #d32f2f;
          }
          .modal-content .cancel-button:hover {
            background: #b71c1c;
          }

          /* Responsive styles for mobile */
          @media (max-width: 768px) {
            .container {
              padding: 0 15px; /* Add some padding on smaller screens */
            }

            .path ul {
              flex-wrap: wrap;
              padding: 0;
              margin: 0;
              justify-content: center; /* Center breadcrumb items on mobile */
            }
            .path ul li {
              margin: 5px;
              font-size: 14px;
            }
            
            /* Hide table header on mobile */
            .MuiTableHead-root {
              display: none !important;
            }

            /* Make table rows act like cards */
            .MuiTableRow-root {
              display: block !important;
              margin-bottom: 15px !important;
              border: 1px solid #ddd !important;
              border-radius: 8px !important;
              padding: 10px !important;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
            }

            /* Style each cell as a row with label */
            .MuiTableCell-root {
              display: flex !important;
              justify-content: space-between !important;
              align-items: center !important;
              padding: 8px !important;
              border: none !important;
              text-align: right !important;
              font-size: 14px !important;
            }

            /* Add labels before content */
            .MuiTableCell-root:before {
              content: attr(data-label);
              font-weight: bold;
              margin-left: 10px;
            }

            /* Center the action buttons */
            .MuiTableCell-root:last-child {
              justify-content: center !important;
            }

            /* Adjust button sizes */
            .MuiButton-root {
              padding: 6px 12px !important;
              font-size: 12px !important;
            }

            /* Make chips smaller on mobile */
            .MuiChip-root {
              height: 24px !important;
              font-size: 12px !important;
            }
            
            .modal-content {
              width: 90%; /* Ensure modal takes up appropriate width */
              margin: 0 10px; /* Add horizontal margin */
            }
          }
        `}
      </style>
      <div className="container mt-xl-0 mb-4">
        {/* Breadcrumb */}
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-3" />
              </li>
              {location.state?.from && (
                <li>
                  <span style={{ cursor: 'pointer' }} onClick={handleBack} className="text-primary">
                    {location.state.from}
                  </span>
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-3" />
                </li>
              )}
              <li>
                <span>گزارش نوبت شما</span>
              </li>
            </ul>
          </div>
        </div>

        {/* نمایش موجودی کیف پول */}
        {renderWalletAmount()}

        {/* Table with MUI */}
        <TableContainer component={Paper} dir="rtl" sx={{ maxWidth: '100%', marginTop: '20px', boxShadow: 'none' }}>
          <Table sx={{ minWidth: { xs: 'auto', sm: 650 } }} aria-label="history table">
            <TableHead>
              <TableRow>
                <TableCell align="center">ردیف</TableCell>
                <TableCell align="center">پزشک</TableCell>
                <TableCell align="center">خدمت</TableCell>
                <TableCell align="center">مبلغ پرداختی</TableCell>
                <TableCell align="center">تاریخ مراجعه</TableCell>
                <TableCell align="center">ساعت مراجعه</TableCell>
                <TableCell align="center">وضعیت</TableCell>
                <TableCell align="center">پرینت نوبت</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : historyData.length > 0 ? (
                historyData.map((item, index) => {
                  const d = new Date(item.TurnDate);
                  const isCancelled = item.CancelReception === true;
                  const turnDateTime = moment(`${item.TurnDate} ${item.TurnTime}`, 'YYYY-MM-DD hh:mm A');
                  const now = moment();
                  
                  const isFutureAndCancellable = turnDateTime.diff(now, 'hours') > 48; // More than 48 hours in future, implies cancellable
                  const isPastAppointment = turnDateTime.isBefore(now); // Appointment is in the past
                  const isFutureAndNotCancellable = !isCancelled && !isFutureAndCancellable && !isPastAppointment; // Future, but within 48 hours, thus not cancellable
                  
                  // Determine status based on conditions
                  let statusContent;
                  if (isCancelled) {
                    statusContent = (
                      <Chip 
                        label="کنسل شده" 
                        color="error" 
                        size="small"
                        sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                      />
                    );
                  } else if (isFutureAndCancellable) {
                    statusContent = (
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => clickHandler(item)}
                        disabled={loading}
                        sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                      >
                        لغو
                      </Button>
                    );
                  } else if (isPastAppointment) {
                    statusContent = (
                      <Chip 
                        label="انجام شده" 
                        color="success" 
                        size="small"
                        sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                      />
                    );
                  } else if (isFutureAndNotCancellable) {
                    statusContent = (
                      <Button 
                        variant="contained"
                        color="warning"
                        size="small"
                        onClick={handleOpenInfoModal}
                        sx={{ 
                          fontSize: { xs: '12px', sm: '14px' },
                          minWidth: 'auto',
                          padding: '4px 12px',
                          textTransform: 'none'
                        }}
                      >
                        رزرو شده
                      </Button>
                    );
                  } else {
                    // Fallback for any unhandled cases
                    statusContent = (
                      <Chip 
                        label="نامشخص" 
                        color="default" 
                        size="small"
                        sx={{ fontSize: { xs: '12px', sm: '14px' } }}
                      />
                    );
                  }

                  return (
                    <TableRow
                      key={item.ID ?? `${item.TransactionNum}-${index}`}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        backgroundColor: isCancelled || isFutureAndNotCancellable ? '#f5f5f5' : 'inherit',
                      }}
                    >
                      <TableCell data-label="ردیف" align="center">{index + 1}</TableCell>
                      <TableCell data-label="پزشک" align="center">{item.DoctorName}</TableCell>
                      <TableCell data-label="خدمت" align="center">{item.ServiceName}</TableCell>
                      <TableCell data-label="مبلغ پرداختی" align="center">{item.ServicePrice ? formatNumberWithPersianSeparators(item.ServicePrice) : '۰'}</TableCell>
                      <TableCell data-label="تاریخ مراجعه" align="center">
                        {new Intl.DateTimeFormat('fa-IR').format(d)}
                      </TableCell>
                      <TableCell data-label="ساعت مراجعه" align="center">
                        {formatTurnTime(item.TurnTime)}
                      </TableCell>
                      <TableCell data-label="وضعیت" align="center">
                        {statusContent}
                      </TableCell>
                      <TableCell data-label="پرینت نوبت" align="center">
                        <AppointmentPDF appointmentData={item} userInfo={userInfo} statusContent={statusContent} />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    نوبتی گرفته نشده است ...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Modal اطلاع‌رسانی */}
      {modal.open && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>{modal.message}</p>
            <button className="btn btn-primary" onClick={handleCloseModal}>
              بستن
            </button>
          </div>
        </div>
      )}

      {/* Modal تأیید لغو */}
      {confirmModal.open && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>تأیید لغو نوبت</h4>
            <p>آیا مطمئن هستید که می‌خواهید این نوبت را لغو کنید؟</p>
            <div className="button-container">
              <button onClick={confirmCancel} disabled={loading}>
                تأیید
              </button>
              <button className="cancel-button" onClick={handleCloseConfirmModal} disabled={loading}>
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal اطلاعات قوانین لغو */}
      {infoModal.open && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>قوانین  سایت</h4>
            <p>نوبت‌هایی که کمتر از ۴۸ ساعت به زمان آنها باقی مانده است طبق قوانین سایت امکان لغو ندارند.</p>
            <div className="button-container">
              <button className="btn btn-primary" onClick={handleCloseInfoModal}>
                متوجه شدم
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};